module Bookhus.Widgets {

    export interface IPopUpMessage {
        id: number;
        active: boolean;
        header: string;
        body: string;
        submitText: string;
        submitRedirect: string;
        startTime: Date;
        endTime: Date;
        showOnEvent: PopUpMessageSowOnEvent;
        showForUser: PopUpMessageSowForUser;
        priority: PopUpMessagePriority;
        showUserFields: boolean;
        showSwornStatement: boolean;
        swornStatementText: string;
    }

    enum PopUpMessagePriority {
        Default,
        Primary,
        Info,
        Warning,
        Danger,
        Success
    }

    enum PopUpMessageSowOnEvent {
        AnyPageView,
        HomePageView,
        LoginPageView
    }

    enum PopUpMessageSowForUser {
        AnyUser,
        LoggedInUser
    }

    export class PopUpMessages {
        private messages: IPopUpMessage[];
        private activeMessage = -1;
        private mask: JQuery;
        private popUp: JQuery;
        private test: boolean;
        private userFieldView: string;
        private callback: any;

        constructor(messages: IPopUpMessage[], loadUserFields = false, test = false, callback = null) {
            var self = this;
            this.test = test;
            this.messages = messages;
            this.callback = callback;
            if (this.messages == null) {
                return;
            }

            if (loadUserFields) {
                $.ajax({
                    url: '/account/GetUserFieldsForDialog',
                    type: 'get',
                    success: function (data) {
                        self.userFieldView = data;
                    },
                    error: function () {
                        //User fields could not be loaded.. remove messages who needs them
                        var filteredMessages: IPopUpMessage[] = [];
                        self.messages.forEach((item) => {
                            if (!item.showUserFields) {
                                filteredMessages.push(item);
                            }
                        });
                        self.messages = filteredMessages;
                    },
                    complete: function () {
                        self.showNextMessage();
                    }
                });
            }
            else {
                this.showNextMessage();
            }
        }

        private showNextMessage(): void {
            if (++this.activeMessage >= this.messages.length) {
                // Afslut. Der er ikke flere beskeder.
                return;
            }

            var message = this.messages[this.activeMessage];
            if (!message) {
                return;
            }

            var userFields = (message: IPopUpMessage) => {
                return !message.showUserFields ? '' : `
                    <form action="/Account/UpdateUserFieldsForDialog" id="dialogForm" method="post">
                        <input type="hidden" name="messageId" value="${message.id}" />
                        ${this.userFieldView}
                        ${(message.showSwornStatement ?
                        `<div class="row form-group" >
                                <div class="col-md-12" >
                                    <label>
                                        <input data-val="true" data-val-required="The SwornStatementAccept field is required." id="SwornStatementAccept" name="SwornStatementAccept" type="checkbox" value="true">
                                        <input name="SwornStatementAccept" type="hidden" value="false">
                                        ${message.swornStatementText}
                                    </label>
                                </div>
                            </div>` : ''
                    )}
                    </form>
                `;
            }



            swalModal.fire({
                title: message.header,
                html: `
                    ${this.scopeStyles(message.body, '.scoped-modal-content')}
                    ${userFields(message)}
                `,
                showConfirmButton: true,
                allowOutsideClick: false,
                confirmButtonText: message.submitText,
                preConfirm: () => {
                    return new Promise((resolve) => {
                        swal.showLoading();
                        swal.resetValidationMessage();

                        if (this.test) {
                            swal.close();
                            resolve(false);
                            return;
                        }

                        if (message.showUserFields) {
                            var $form = $('#dialogForm');
                            $.ajax({
                                cache: false,
                                url: $form.attr('action'),
                                type: $form.attr('method'),
                                data: $('#dialogForm').serializeArray(),
                                success: () => {
                                    resolve(message);
                                },
                                error: function (xhr) {
                                    swal.showValidationMessage(xhr.status == 401 ? 'Du skal være logget ind for at kunne opdatere dine oplysninger.' : xhr.statusText);
                                    resolve(false);
                                }
                            });
                        }
                        else {
                            $.ajax({
                                url: "/api/PopUpMessages",
                                cache: false,
                                method: "POST",
                                data: { "": this.messages[this.activeMessage].id }
                            }).always(() => {
                                resolve(message);
                            });
                        }
                    });
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.handleRedirect(message);
                }
            });

            this.executeCallback();
        }


        private executeCallback(): void {
            if (typeof this.callback === "function") {
                this.callback();
            }
        }

        private scopeStyles(content, scopeClass) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(content, 'text/html');
            const styleTags = doc.querySelectorAll('style');
            let scopedCSS = '';
            styleTags.forEach((style) => {
                scopedCSS += style.innerHTML.replace(/([^\{\}]+)\s*(\{[^}]*\})/g, (match, selectors, rules) => {
                    const scopedSelectors = selectors
                        .split(',')
                        .map((selector) => {
                            if (selector.trim() === 'body') {
                                return scopeClass;
                            }
                            return `${scopeClass} ${selector.trim()}`;
                        })
                        .join(', ');
                    return `${scopedSelectors} ${rules}`;
                });
            });
            const bodyContent = Array.from(doc.body.children)
                .filter((child) => child.tagName.toLowerCase() !== 'style')
                .map((child) => child.outerHTML)
                .join('');
            return `
            <div class="${scopeClass.replace('.', '')}">
                <style>${scopedCSS}</style>
                ${bodyContent}
            </div>
            `;
        }

        private handleRedirect(message: IPopUpMessage) {
            if (!message.submitRedirect) {
                return;
            }

            var redirectLink = message.submitRedirect.trim();
            if (this.test) {
                alert(`Brugeren vil blive viderestillet til:\n${redirectLink}`);
                return;
            }
            window.location.href = redirectLink;
        }
    }


    export class PopUpMessageTools {

        static priorityPicker(selector: string): void {
            var target = $(selector);
            var labels = target.siblings("label");
            var color = this.getPriorityColor(target.val());
            labels.before(`<span class="badge badge-pill priority-color-badge ${color}">&nbsp;</span>&nbsp; `);
            target.on("change", () => {
                var badges = labels.siblings(".priority-color-badge");
                var color = this.getPriorityColor(target.val());
                badges.replaceWith(`<span class="badge badge-pill priority-color-badge ${color}">&nbsp;</span>`);
            });
        }

        static getPriorityColor(enumValue: number): string {

            // Denne metode kan kaldes fra ekstern JS, så sørg for at enumValue er number
            var enumValueNumber = +enumValue;

            if (typeof PopUpMessagePriority[enumValueNumber] === "undefined" || enumValueNumber === PopUpMessagePriority.Default) {
                return "brand-background";
            }
            var priority = PopUpMessagePriority[enumValueNumber].toLowerCase();
            return `bg-${priority}`;
        }

        static testMessage(messages: IPopUpMessage[]): void {
            var popUps = new PopUpMessages(messages, true, true);
        }

    }

}
